import { EmptyStateInfinite } from '@assets/icons';
import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

export default function EmptyState() {
    return (
        <Flex alignItems={'center'} gap={'12px'}>
            <Box>
                <EmptyStateInfinite />
            </Box>
            <Text>
                Produk yang Anda cari tidak dapat ditemukan atau produk belum ter-{' '}
                <Box display={'inline'} color={'danger.500'} fontStyle={'italic'}>
                    mapping
                </Box>
                . Cek kembali kata kunci Anda atau hubungi admin.
            </Text>
        </Flex>
    );
}
